import { Component, CUSTOM_ELEMENTS_SCHEMA, Input, OnInit } from '@angular/core';
import { IonicModule } from '@ionic/angular';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { ToolService } from '@app/core/services/tool/tool.service';
import { ModalController } from '@ionic/angular';

@Component({
  selector: 'app-action-confirmation',
  templateUrl: './action-confirmation.component.html',
  styleUrls: ['./action-confirmation.component.scss'],
    standalone: true,
    imports: [CommonModule, FormsModule, ReactiveFormsModule, IonicModule],
    schemas: [CUSTOM_ELEMENTS_SCHEMA]})
export class ActionConfirmationComponent implements OnInit {

  @Input() data?: any;

  constructor(
    private modal: ModalController,
    public toolService: ToolService
  ) { }

  ngOnInit() {
    if (!this.data.buttonColor) {
      this.data.buttonColor = 'primary';
    }
  }

  dismiss = () => {
    this.modal.dismiss({confirmed: false, params: {}});
  }

  continue = () => {
    this.modal.dismiss({confirmed: true, params: this.data});
  }

}
